import { api } from '@/api/api'
import { ModelFileItem } from '@/types/mock-api-types'
import { camelizeKeys } from '@/utils/humps'

const fileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<ModelFileItem[], FormData>({
      query: (attachment) => {
        return {
          url: '/file',
          method: 'POST',
          body: attachment,
        }
      },
      transformResponse(response: ModelFileItem[]) {
        return camelizeKeys(response) as unknown as ModelFileItem[]
      },
    }),
  }),
})

export const useUploadFileMutation = fileApi.endpoints.uploadFile.useMutation
